import OnboardingInterestsModule from './OnboardingInterestsModule'

export default OnboardingInterestsModule
